import { Typography } from '@capsule/consumer-design-system';

import styled from 'styled-components';

export const NonTransferrableMedicationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.s4};
  color: ${({ theme }) => theme.colors.capsuleGray50};
  svg {
    fill: ${({ theme }) => theme.colors.capsuleGray50};
  }
`;

export const MedicationBlockTitle = styled(Typography).attrs({ variant: 'overline' })`
  margin-bottom: ${({ theme }) => theme.space.s2};
`;
